import { render, staticRenderFns } from "./ArticleLarge.vue?vue&type=template&id=6d77d3e4&"
import script from "./ArticleLarge.vue?vue&type=script&lang=ts&"
export * from "./ArticleLarge.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleLarge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdaptiveImageNew: require('/tmp/build_453bf6d7/src/components/media/AdaptiveImageNew.vue').default,ButtonCircle: require('/tmp/build_453bf6d7/src/components/button/Circle.vue').default,NuxtLinkExternal: require('/tmp/build_453bf6d7/src/components/misc/NuxtLinkExternal.vue').default})
